import { invokeApi } from "../../bl_libs/invokeApi";

export const quotesListing = async (data) => {
  const requestObj = {
    path: `api/quotation`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
